
import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "@/components/main-header.vue";
import {
  GetNewsTems,
  UploadFile,
  PostCepingContent,
  GetTemDetail,
  EditContent,
  GetExeImg,
} from "@/request/common";
import { getCurrentTime } from "@/utils/base";
@Component({
  components: {
    MainHeader,
  },
})
export default class Name extends Vue {
  private cdata: any = 0;
  private data: any = [];
  private type: any = "";
  private visible: any = false;
  private stream: any = "";
  private photoData: any = "";
  private imgData: any = [];
  private imgs: any = [];
  private devices: any = [];
  private cDevice: any = {};
  private filming: any = false;
  private times: any = 0; // 当前查找次数
  private maxTimes: any = 4; // 最大重复次数
  private uid: any = "";
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get patient() {
    return this.$store.state.patient;
  }
  private async goCaiji() {
    this.cdata = 0;
    this.visible = true;
    this.getCameraDevices();
  }
  private cancel() {
    if (this.stream) {
      this.stream.getTracks().forEach((track: any) => track.stop());
    }
    this.resetCamera();
    this.imgs = [];
    this.imgData = [];
    this.devices = [];
    this.cDevice = {};
    this.filming = false;
    this.visible = false;
  }
  private next() {
    this.cdata += 1;
    if (this.data[this.cdata].data[0].type == "脉象") {
      this.GoMaiDevices();
    }
  }
  // 调取脉象设备拍摄,这里拍摄完成后会直接调取保存接口
  private GoMaiDevices() {
    console.log("拍脉");
    this.$confirm("确定开始采集脉象吗!", "脉象采集", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
      closeOnClickModal: false,
      closeOnPressEscape: false,
      confirmButtonText: "开始采集",
      cancelButtonText: "跳过",
    })
      .then(() => {
        this.uid = Date.now() + "_" + this.patient.id;
        window.electronMyAPI.launchExe("pulse", this.uid);
        // 弹出中间弹框
        this.$confirm("确定脉象已采集完成吗!", "脉象采集", {
          customClass: "commonConfirm",
          confirmButtonClass: "iconfont icon-anniu4 confirmSure",
          cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
          closeOnClickModal: false,
          closeOnPressEscape: false,
          confirmButtonText: "采集完成",
          cancelButtonText: "跳过",
        })
          .then(async () => {
            // 上传脉
            const loading = this.$loading({
              lock: true,
              text: "加载中……",
              spinner: "el-icon-loading",
              customClass: "loadClass",
              background: "rgba(255, 255, 255, 0.7)",
            });
            const res = await window.electronMyAPI.uploadPulse(this.uid);

            // 先获取图片填充到value，然后保存content
            const params: any = {
              params: {
                uid: res,
                name: "pulse",
              },
            };
            GetExeImg(this, params, loading).then((res: any) => {
              loading.close();
              if (res.code == 2000) {
                this.data[this.cdata].data[0].value = res.data.imgs;
                // 修改report
                this.data[this.cdata].report = res.data.report;
                this.clickSure();
              } else {
                this.$confirm(
                  "对不起，报告查看失败，请重新采集！",
                  "脉象采集",
                  {
                    customClass: "commonConfirm",
                    confirmButtonClass: "iconfont icon-anniu4 confirmSure",
                    cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    confirmButtonText: "重新采集",
                    cancelButtonText: "跳过",
                  }
                )
                  .then(() => {
                    this.GoMaiDevices();
                  })
                  .catch(() => {
                    this.maiNext();
                  });
              }
            });
          })
          .catch(() => {
            this.maiNext();
          });
      })
      .catch(() => {
        this.maiNext();
      });
  }
  private maiNext() {
    // 如果是最后一个，因为这里是触发下一个，所以直接跳转报告
    if (this.cdata == this.data.length - 1) {
      this.goReport();
    } else {
      this.next();
    }
  }
  private preview(url: any) {
    window.open(url);
  }
  private resetPhoto() {
    this.imgs = [];
    this.imgData = [];
    this.resetCamera();
    this.startCamera();
  }
  private selectDevice(item: any) {
    this.cDevice = item;
    this.startCamera();
  }
  private base64ToBlob(base64Data: string, contentType = ""): Blob {
    contentType = contentType || base64Data.split(",")[0].split(":")[1];
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data.split(",")[1]);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  private async startCamera() {
    try {
      this.stream = await navigator.mediaDevices.getUserMedia({
        // video: true,
        video: {
          deviceId: { exact: this.cDevice.deviceId },
        },
      });
      (this.$refs.video as any).srcObject = this.stream;
      (this.$refs.video2 as any).srcObject = this.stream;
    } catch (err) {
      console.error("Error accessing the camera:", err);
      this.$message.warning("请再点击一次");
      // this.devices = [];
      this.cDevice = {};
      this.getCameraDevices();
    }
  }
  private startTakePhoto() {
    this.takePhoto().then(() => {
      const loading = this.$loading({
        lock: true,
        text: "图片上传中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      this.upload(this.imgData[0]).then(() => {
        loading.close();
        this.filming = false;
      });
    });
    return;
    if (this.filming) {
      return;
    }
    // 第一次拍摄
    this.filming = true;
    this.changeLight().then(() => {
      this.takePhoto().then(() => {
        // 第二次拍摄
        this.changeLight().then(() => {
          this.takePhoto().then(() => {
            // 第三次拍摄
            this.changeLight().then(() => {
              this.takePhoto().then(async () => {
                const res = await window.electronMyAPI.changeLight(
                  "平行光-OFF"
                );
                // 延时1秒调光
                if (res) {
                  // 保存图片
                  const loading = this.$loading({
                    lock: true,
                    text: "图片上传中……",
                    spinner: "el-icon-loading",
                    customClass: "loadClass",
                    background: "rgba(255, 255, 255, 0.7)",
                  });
                  this.upload(this.imgData[0]).then(() => {
                    this.upload(this.imgData[1]).then(() => {
                      this.upload(this.imgData[2]);
                      loading.close();
                      this.filming = false;
                    });
                  });
                }
              });
            });
          });
        });
      });
    });
  }
  private changeLight() {
    return new Promise(async (resolve, reject) => {
      if (this.imgData.length == 0) {
        const res = await window.electronMyAPI.changeLight("白光-ON-100");
        // 延时1秒调光
        if (res) {
          resolve(true);
        }
      } else if (this.imgData.length == 1) {
        const res = await window.electronMyAPI.changeLight("白光-OFF");
        if (res) {
          const res2 = await window.electronMyAPI.changeLight("绿光-ON");
          if (res2) {
            resolve(true);
          }
        }
      } else if (this.imgData.length == 2) {
        const res = await window.electronMyAPI.changeLight("绿光-OFF");
        if (res) {
          const res2 = await window.electronMyAPI.changeLight("平行光-ON");
          if (res2) {
            resolve(true);
          }
        }
      }
    });
  }
  private takePhoto() {
    return new Promise((resolve, reject) => {
      if (this.stream) {
        const video = this.$refs.video as HTMLVideoElement;
        // const canvas = this.$refs.canvas as HTMLCanvasElement;
        const canvas = document.createElement("canvas"); // 创建一个新的canvas元素，不添加到DOM中

        // 设置 Canvas 尺寸为视频帧旋转后的尺寸
        canvas.width = video.videoHeight; // 旋转后的宽度是原始高度
        canvas.height = video.videoWidth; // 旋转后的高度是原始宽度
        const context: any = canvas.getContext("2d");

        // 清除画布
        context.clearRect(0, 0, canvas.width, canvas.height);

        // 保存当前状态
        context.save();

        // 转换原点至画布中心
        context.translate(canvas.width / 2, canvas.height / 2);

        // 旋转画布90度（顺时针）
        context.rotate(Math.PI / 2);

        // 绘制视频帧
        context.drawImage(
          video,
          0,
          0, // 从视频左上角开始，绘制整个视频帧
          video.videoWidth,
          video.videoHeight, // 视频帧的原始宽度和高度
          -video.videoWidth / 2,
          -video.videoHeight / 2, // 从画布中心点的x轴负方向开始（旋转后的y轴）
          video.videoWidth,
          video.videoHeight // 使用视频帧的原始尺寸绘制到画布上
        );

        // 恢复状态
        context.restore();

        // 捕获旋转后的图像数据
        // this.photoData = canvas.toDataURL("image/png");
        // this.imgData.push(this.photoData);
        canvas.toBlob(
          (blob) => {
            if (blob) {
              // 创建一个 FileReader 来读取 Blob 并转换为 DataURL（如果需要的话）
              const reader = new FileReader();
              reader.onload = (e: any) => {
                this.photoData = e.target.result;
                this.imgData.push(this.photoData);
                resolve(true);
              };
              reader.readAsDataURL(blob);
            } else {
              reject(new Error("Failed to generate image blob"));
            }
          },
          "image/jpeg",
          0.7
        ); // 这里指定了输出格式为 JPEG，并设置了质量为 0.7
      }
    });
  }
  private resetCamera() {
    console.log("重新拍摄");
    // 重置photoData和Canvas
    this.stream = "";
    this.photoData = "";
    const canvas = this.$refs.canvas as HTMLCanvasElement;

    if (canvas) {
      const context: any = canvas.getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);
    }
  }
  private sure() {
    this.data[this.cdata].data[0].value = {
      imgs: this.imgs,
    };
    this.clickSure();
  }
  private clickSure() {
    if (this.cdata == this.data.length - 1) {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      this.save(this.cdata).then((res: any) => {
        loading.close();
        this.goReport();
      });
    } else {
      this.save(this.cdata);
      //   this.cdata += 1;
      this.next();
      this.resetPhoto();
    }
  }
  private goReport() {
    let ids: any = [];
    this.data.forEach((ele: any) => {
      if (ele.content && ele.content.id) ids.push(ele.content.id);
    });
    this.$router.push({
      path: "/main/report/ceping-report",
      query: {
        ids: JSON.stringify(ids),
      },
    });
  }
  private save(index: any) {
    return new Promise((resolve, reject) => {
      const params: any = {
        collect_time: getCurrentTime("yyyy-MM-dd HH:mm:ss"),
        patient: this.patient.id,
        related_type: this.type,
        template: this.data[index].template,
        data: this.data[index].data,
      };
      if (this.data[index].report) {
        params.report = this.data[index].report;
      }
      PostCepingContent(this, params)
        .then((res: any) => {
          if (
            res.data.data[0].type == "舌象80" ||
            res.data.data[0].type == "舌底" ||
            res.data.data[0].type == "面象15"
          ) {
            if (res.data.data[0].type == "面象15") {
              if (!res.data.report["面象信息"]) {
                res.data.report["面象信息"] = {
                  面色: [],
                  唇态: ["润"],
                  唇色: [],
                  鼻光泽: ["有光泽"],
                  鼻形态: ["正常"],
                  鼻颜色: ["正常肤"],
                  人中形态: ["短浅"],
                  人中颜色: ["正常肤色"],
                };
                // 转格式,填充数据
                const oldData: any = res.data.report["面象信息输出"];
                // 面色
                if (oldData[0]) {
                  const text: any = oldData[0];
                  res.data.report["面象信息"]["面色"].push(text);
                }
                if (oldData[1] && oldData[1] == "有") {
                  res.data.report["面象信息"]["面色"].push("两颧红");
                }
                if (oldData[2] && oldData[2] == "有") {
                  res.data.report["面象信息"]["面色"].push("眼眶黑");
                }
                if (oldData[3]) {
                  const text: any = oldData[3];
                  res.data.report["面象信息"]["面色"].push(text);
                }

                // 唇色
                if (oldData[4]) {
                  const text: any = oldData[4];
                  res.data.report["面象信息"]["唇色"].push(text);
                }
              }
            } else if (res.data.data[0].type == "舌象80") {
              if (!res.data.report["舌象信息"]) {
                res.data.report["舌象信息"] = {
                  舌神: [[], []],
                  舌色: [[], []],
                  舌形: [[], []],
                  舌态: [[], []],
                  苔质: [[], []],
                  苔色: [[], []],
                };
                // 转格式,填充数据
                const oldData: any = res.data.report["舌象信息输出"];
                // 舌色
                if (oldData[0]) {
                  const text: any = oldData[0];
                  res.data.report["舌象信息"]["舌色"][0].push(text);
                }
                // 边尖红
                if (oldData[1] && oldData[1] == "有") {
                  res.data.report["舌象信息"]["舌色"][1].push("边尖红");
                }
                // 瘀斑瘀点
                if (oldData[2] && oldData[2] == "有") {
                  res.data.report["舌象信息"]["舌形"][0].push("有瘀斑瘀点");
                }
                // 苔色
                if (oldData[3]) {
                  const text: any = oldData[3];
                  res.data.report["舌象信息"]["苔色"][0].push(text);
                }
                // 厚薄
                if (oldData[4]) {
                  const text: any = oldData[4];
                  res.data.report["舌象信息"]["苔质"][0].push(text);
                }
                // 腻
                if (oldData[5] && oldData[5] == "有") {
                  res.data.report["舌象信息"]["苔质"][0].push("腻");
                }
                // 腐
                if (oldData[6] && oldData[6] == "有") {
                  res.data.report["舌象信息"]["苔质"][0].push("腐");
                }
                // 苔剥
                if (oldData[7] && oldData[7] == "有") {
                  res.data.report["舌象信息"]["苔质"][0].push("有苔剥");
                }
                // 胖瘦
                if (oldData[8]) {
                  const text: any = oldData[8];
                  res.data.report["舌象信息"]["舌形"][0].push(text);
                }
                // 齿痕
                if (oldData[9] && oldData[9] == "有") {
                  res.data.report["舌象信息"]["舌形"][0].push("有齿痕");
                }
                // 点刺
                if (oldData[10] && oldData[10] == "有") {
                  res.data.report["舌象信息"]["舌形"][0].push("有点刺");
                }
                // 裂纹
                if (oldData[11] && oldData[11] == "有") {
                  res.data.report["舌象信息"]["舌形"][0].push("有裂纹");
                }
                res.data.report["舌象信息"]["舌神"][0].push("荣");
                res.data.report["舌象信息"]["舌态"][0].push("正常");
                this.$forceUpdate();
              }
            } else if (res.data.data[0].type == "舌底") {
              if (!res.data.report["舌底信息"]) {
                res.data.report["舌底信息"] = {
                  长度: "正常",
                  形态: "双支",
                  颜色: "淡红含浅蓝",
                  粗细: "正常",
                };
              }
            } else if (res.data.data[0].type == "脉象") {
              if (res.data.report) {
                if (
                  (res.data.report["左手脉象信息输出"] &&
                    res.data.report["左手脉象信息输出"]["脉名"] == "其它脉") ||
                  (res.data.report["右手脉象信息输出"] &&
                    res.data.report["右手脉象信息输出"]["脉名"] == "其它脉")
                ) {
                  if (
                    res.data.report["左手脉象信息输出"] &&
                    res.data.report["左手脉象信息输出"]["脉名"] == "其它脉"
                  ) {
                    res.data.report["左手脉象信息输出"]["脉名"] = "大脉";
                  }
                  if (
                    res.data.report["右手脉象信息输出"] &&
                    res.data.report["右手脉象信息输出"]["脉名"] == "其它脉"
                  ) {
                    res.data.report["右手脉象信息输出"]["脉名"] = "大脉";
                  }
                }
              }
            }
            EditContent(this, res.data.id, res.data)
              .then((res: any) => {
                this.data[index].content = res.data;
                resolve(res.data);
              })
              .catch(() => {
                reject();
              });
          } else {
            this.data[index].content = res.data;
            resolve(res.data);
          }
        })
        .catch(() => {
          reject();
        });
    });
  }
  private upload(d: any) {
    return new Promise((resolve, reject) => {
      // 将 photoData 转换为 Blob 对象
      const blob = this.base64ToBlob(d);
      // 获取当前时间的时间戳（毫秒级）
      const timestamp = Date.now();
      const filename = `${timestamp}.jpg`;
      // FormData 对象
      const form = new FormData();
      // Blob 对象作为文件添加到表单中
      form.append("file", blob, filename); // 可以指定文件名

      UploadFile(this, form)
        .then((res: any) => {
          this.imgs.push(res.data);
          resolve(res.data);
        })
        .catch(() => {
          reject();
        });
    });
  }
  private async getCameraDevices() {
    this.times = 1;
    console.log("查找次数：" + this.times);
    const loading = this.$loading({
      lock: true,
      text: "查找设备中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        // alert("enumerateDevices 不可用");
        loading.close();
        // this.$message.warning("enumerateDevices 不可用");
        setTimeout(() => {
          this.getCameraDevices2();
        }, 1000);
        return;
      }

      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          console.log('设备列表')
          console.log(devices);
          this.devices = devices.filter(
            (device) => device.kind === "videoinput"
          );
          loading.close();
          if (this.devices.length == 0) {
            // this.$message.warning("没有符合条件的设备");
            setTimeout(() => {
              this.getCameraDevices2();
            }, 1000);
          }
        })
        .catch((error) => {
          console.error("列出摄像头时发生错误:", error);
          loading.close();
          // this.$message.warning("没有符合条件的设备");
          setTimeout(() => {
            this.getCameraDevices2();
          }, 1000);
        });
    } catch (err) {
      console.error("Error accessing the camera:", err);
      loading.close();
      // this.$message.warning("没有符合条件的设备");
      setTimeout(() => {
        this.getCameraDevices2();
      }, 1000);
    }
  }
  private async getCameraDevices2() {
    this.times += 1;
    console.log("查找次数：" + this.times);
    const loading = this.$loading({
      lock: true,
      text: "查找设备中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    try {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        // alert("enumerateDevices 不可用");
        loading.close();
        // this.$message.warning("enumerateDevices 不可用");
        setTimeout(() => {
          if (this.times < 5) {
            this.getCameraDevices2();
          }
        }, 1000);
        return;
      }

      navigator.mediaDevices
        .enumerateDevices()
        .then((devices) => {
          console.log('设备列表')
          console.log(devices);
          this.devices = devices.filter(
            (device) => device.kind === "videoinput"
          );
          loading.close();
          if (this.devices.length == 0) {
            // this.$message.warning("没有符合条件的设备");
            setTimeout(() => {
              if (this.times < this.maxTimes) {
                this.getCameraDevices2();
              }
            }, 1000);
          }
        })
        .catch((error) => {
          console.error("列出摄像头时发生错误:", error);
          loading.close();
          // this.$message.warning("没有符合条件的设备");
          setTimeout(() => {
            if (this.times < this.maxTimes) {
              this.getCameraDevices2();
            }
          }, 1000);
        });
    } catch (err) {
      console.error("Error accessing the camera:", err);
      loading.close();
      // this.$message.warning("没有符合条件的设备");
      setTimeout(() => {
        if (this.times < this.maxTimes) {
          this.getCameraDevices2();
        }
      }, 1000);
    }
  }
  private destroyed() {
    // 关闭均匀光
    window.electronMyAPI.changeLight("白光-OFF");
  }
  private getData() {
    const params: any = {
      params: {
        patient_id: this.patient.id,
        related_type: this.type,
      },
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    GetNewsTems(this, params, loading).then((res: any) => {
      this.data = [];
      res.data[this.type].forEach((ele: any) => {
        this.data.push({
          patient: this.patient.id,
          related_type: this.type,
          template: {
            id: ele.id,
            name: ele.name,
          },
          data: JSON.parse(JSON.stringify(ele.template_data)) || "",
          content: {},
        });
        // GetTemDetail(this, ele.id).then((res: any) => {
        //   this.data.push({
        //     patient: this.patient.id,
        //     related_type: this.type,
        //     template: JSON.parse(JSON.stringify(res.data)),
        //     data: JSON.parse(JSON.stringify(res.data.fields)) || "",
        //     content: {},
        //   });
        // });
      });
      console.log("数据");
      console.log(this.data);
    });
  }
  private async mounted() {
    // 关闭紫光
    console.log("打开弹框后：紫外光-OFF");
    const res = await window.electronMyAPI.changeLight("紫外光-OFF");
    if (res) {
      this.$store.commit("updateIfShowZiwai", false);
      // 打开均匀光
      console.log("打开弹框后：白光-ON-100");
      window.electronMyAPI.changeLight("白光-ON-100");
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    this.getData();
  }
}
